import { reactive } from 'vue';

export const asyncObject = Object.freeze({
    wrap(promiseOrObject) {
        const result = this.pending();
        Promise.resolve(promiseOrObject).then(x => result.value = x);
        return result;
    },

    pending() {
        let value = null, resolve = null;
        const promise = new Promise(x => resolve = x);
        const result = reactive({
            ready: false,
            get value() {
                return value;
            },
            set value(val) {
                value = val;
                this.ready = true;
                resolve(this.value);
            },
            wait() {
                return promise;
            },
        });

        return result;
    },

    /**
	 * @template T
	 * @param {T|Promise<T>} defaultValue 
	 * @returns {{ready: boolean, value: T }}
	 */
    complete(value) {
        const result = this.pending();
        result.value = value;
        return result;
    },
});